module.exports = "<div [hidden]=\"!isLoading\" class=\"text-xs-center loaderWrapper\">\r\n  <i class=\"fa fa-cog fa-spin fa-3x\"></i> <span>{{message}}</span>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/app/shared/components/loader/loader.component.html
// module id = ../../../../../src/app/shared/components/loader/loader.component.html
// module chunks = main